import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useT } from '../i18n';
import { pautkanTeks } from './artikelKongsi';
import useMaintenanceGate from '../hooks/useMaintenanceGate';
import './MaintenanceGate.css';

// ══════════════════════════════════════════════════════════════════
//  MAINTENANCE GATE — modal penuh skrin, TIADA butang tutup (2026-09-28)
//  - Dipasang SEKALI dalam main.jsx (sebelah <App />), bukan dalam App.jsx:
//    App.jsx ada banyak `return` awal (semakan lesen, StartGate, /flow…)
//    dan semakan lesen itu sendiri bergantung pada Cloud Functions — bila
//    server down pelanggan boleh tersangkut di situ. Di main.jsx modal
//    menutup SEMUA halaman log masuk.
//  - Esc / klik latar tidak menutup. Hilang sendiri bila admin OFF.
//  - Suis + teks: useMaintenanceGate.js · admin: MaintenanceGateAdmin.jsx.
// ══════════════════════════════════════════════════════════════════

export function MaintenanceGateModal({ title, body, onTutup }) {
  const t = useT();

  useEffect(() => {
    // Kunci skrol halaman di belakang + telan Esc (fasa capture, supaya
    // modal/pintasan lain di bawah tidak bertindak).
    const asal = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const telanEsc = (e) => {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      e.preventDefault();
      if (onTutup) onTutup();
    };
    window.addEventListener('keydown', telanEsc, true);
    return () => {
      document.body.style.overflow = asal;
      window.removeEventListener('keydown', telanEsc, true);
    };
  }, [onTutup]);

  return createPortal(
    <div className="mg-latar" role="alertdialog" aria-modal="true" aria-labelledby="mg-tajuk">
      <div className="mg-kotak">
        <div className="mg-ikon" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>
        <h2 id="mg-tajuk" className="mg-tajuk">{title || t('maintenance.defaultTitle')}</h2>
        <div className="mg-isi">{pautkanTeks(body || t('maintenance.defaultBody'))}</div>
        <p className="mg-nota">{t('maintenance.autoNote')}</p>
        {onTutup && (
          <button type="button" className="mg-tutup-pratonton" onClick={onTutup}>
            Close preview (admin only)
          </button>
        )}
      </div>
    </div>,
    document.body
  );
}

export default function MaintenanceGate() {
  const gate = useMaintenanceGate();
  if (!gate.aktif) return null;
  return <MaintenanceGateModal title={gate.title} body={gate.body} />;
}
